import { stringify as qsStringify } from 'query-string';
import { batchActions } from './utils';
import { setData, unsetData } from './data';
import { setStatus, unsetStatus } from './status';
import {
  LOADING,
  ERROR,
  selectEpisodeListStatus,
  selectEpisodeList,
  selectDateRange,
} from './selectors';
import { toJSON, PODCASTERS_SERVICE } from '../lib/Request';
import { Thunk, DateRangeWithLabel, PaginatedEpisodes } from '../types';

const KEY = 'episodeList';
const TABLE_PAGE_SIZE = 50;

export const loadEpisodeList = (
  podcastId: string,
  filter: string,
  page: number,
  sortBy: string,
  sortDecending: boolean,
): Thunk => async (dispatch, getState, { request }) => {
  const { startDate: start, endDate: end, label } = selectDateRange(
    getState(),
  ) as DateRangeWithLabel;
  /* istanbul ignore next */
  const sortOrder = sortDecending ? 'descending' : 'ascending';
  let params = qsStringify({ page, filter, start, end, sortBy, sortOrder, size: TABLE_PAGE_SIZE });

  if (label === 'First 30 days') {
    params = params.concat('&daysSinceRelease=30');
  } else if (label === 'First 90 days') {
    params = params.concat('&daysSinceRelease=90');
  }

  const endpoint = `${PODCASTERS_SERVICE}/v0/shows/${podcastId}/episodes?${params}`;

  /* istanbul ignore next */
  if (selectEpisodeListStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [KEY]: LOADING }, 'audience/LOAD_EPISODE_LIST_REQUEST'));

  try {
    const data: PaginatedEpisodes = await request.get(endpoint).then(toJSON);

    dispatch(
      batchActions(
        [setData({ [KEY]: data }), unsetStatus([KEY])],
        'audience/LOAD_EPISODE_LIST_SUCCESS',
      ),
    );
  } catch (err) {
    switch (err.name) {
      case 'ResponseError':
      case 'TokenError': {
        const episodeList = selectEpisodeList(getState());
        dispatch(
          batchActions(
            [
              setStatus({ [KEY]: ERROR }),
              setData({
                [KEY]: { ...episodeList, currentPage: page, episodes: [] } as PaginatedEpisodes,
              }),
            ],
            'audience/LOAD_EPISODE_LIST_ERROR',
          ),
        );
        break;
      }

      /* istanbul ignore next */
      default:
        throw err;
    }
  }
};

export const unsetEpisodeList = (): Thunk => async dispatch => dispatch(unsetData(['episodeList']));
